import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-hebergement',
    templateUrl: './hebergement.component.html',
    styleUrls: ['./hebergement.component.scss']
})

export class HebergementComponent implements OnInit {
    model = {
        left: true,
        middle: false,
        right: false
    };

    focus;
    focus1;
    constructor() { }

    ngOnInit() {}
}
